import { render, staticRenderFns } from "./EditMarkerModal.vue?vue&type=template&id=3835489a&scoped=true&"
import script from "./EditMarkerModal.vue?vue&type=script&lang=js&"
export * from "./EditMarkerModal.vue?vue&type=script&lang=js&"
import style0 from "./EditMarkerModal.vue?vue&type=style&index=0&id=3835489a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835489a",
  null
  
)

export default component.exports